import { Button, Navbar, NavbarBrand, NavbarContent } from "@heroui/react";
import { Outlet } from "react-router";
import { useTheme } from '@heroui/use-theme';
import { LuSun, LuMoon, LuLogOut } from 'react-icons/lu';
import { AuthContext } from "@panamod/react-utils";
import { Fragment, useContext, useEffect } from "react";
import { useDialog, useLogout } from "@/hooks";
import useStore from "@/store/main/action";
import { ExitDialog } from "..";

const NavBar = () => {
    const { resetReducer, storeState, cDescripcion, backgroundImg } = useStore();
    const { open, handleOpenDialog, handleCancelar } = useDialog();
    const { theme, setTheme } = useTheme();
    const { userData } = useContext(AuthContext)

    const handleChangeMode = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark');
    }
    useEffect(() => {
        resetReducer();
    }, []);
    const isEncuestaToken = location.pathname.startsWith('/encuestaToken');
    const { handleLogout, encuestaId } = useLogout(resetReducer, storeState);
    const show = userData?.nUsuario ?? isEncuestaToken;
    console.log(backgroundImg)
    return (
        <div className='flex flex-col h-screen w-screen overflow-auto'>
            <Navbar
                className={`bg-default-100`}
                classNames={{
                    item: [
                        "data-[active=true]:after:bg-primary"
                    ]
                }}
            >
                <NavbarContent justify='start'>
                    <NavbarBrand>
                        <p className="font-bold text-inherit">Encuestas</p>
                    </NavbarBrand>
                </NavbarContent>
                <NavbarContent justify="center">
                    {cDescripcion && (
                        <h4 className="text-center text-sm w-full whitespace-normal word line-clamp-2 max-h-9 text-ellipsis font-bold">
                            {cDescripcion}
                        </h4>
                    )}
                </NavbarContent>
                <NavbarContent justify="end">
                    {
                        (userData) ?  (
                            <h4 className="text-sm max-w-24 whitespace-normal line-clamp-2 max-h-9 text-ellipsis">{userData.cNombre}</h4>
                        ): (
                            <Fragment key={'No user data'}/>
                        )
                    }
                    {((show && isEncuestaToken) || encuestaId) ? null : (
                        <Button isIconOnly onPress={handleOpenDialog}>
                            <LuLogOut />
                        </Button>
                    )}
                    <Button isIconOnly size='md' onPress={handleChangeMode} >
                        {theme === 'dark' ? <LuSun /> : <LuMoon />}
                    </Button>
                </NavbarContent>
            </Navbar>
            <div className='flex flex-1 p-2' 
            style={{
                backgroundImage: backgroundImg
                    ? `url(${backgroundImg})`
                    : undefined,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                // filter: backgroundImg && theme === 'light' ? 'invert(1)' : 'none',
            }}>
                <Outlet />
            </div>
            <ExitDialog
                title="¿Está seguro que desea cerrar sesión?"
                subtitle=""
                open={open}
                handleCancelar={handleCancelar}
                handleAceptar={handleLogout}
            />
        </div>
    )
}
export default NavBar